import { css } from "@stubhub/broadway-foundation/css";
import { TicketOutlineIcon } from "@stubhub/broadway-web/icons/functional";
import { FormatContent } from "src/shared/components/content";

const bannerWrapper = css({
  display: "flex",
  alignItems: "center",
  columnGap: "primitives.100",
  color: "text.onDark",
  paddingBlockEnd: "[10px]",
  paddingInlineStart: "primitives.200",
  paddingInlineEnd: "primitives.200",
  // phone (base)
  fontSize: "[13px]",
  lineHeight: "[19px]",
  paddingBlockStart: "primitives.0",
  backgroundColor: "[transparent]",
  justifyContent: "center",
  maxWidth: "[250px]",
  alignSelf: "center",
  textAlign: "center",
  // tablet and above
  tablet: {
    fontSize: "primitives.350",
    lineHeight: "primitives.400",
    paddingBlockStart: "[10px]",
    backgroundColor: "bg.dark",
    alignSelf: "stretch",
  },
  "& b": {
    fontWeight: "bold",
    fontSize: "primitives.400",
    lineHeight: "primitives.400",
  },
});

const iconWrapper = css({
  display: { base: "none", tablet: "block" },
});

export const OfficialMarketplaceBanner = ({ performerName }: { performerName: string }) => {
  return (
    <div className={bannerWrapper}>
      <span className={iconWrapper}>
        <TicketOutlineIcon size={20} />
      </span>

      {/** "Official marketplace partners of [performerName] " */}
      <FormatContent id="cid$#3802475#" params={[performerName]} raw />
    </div>
  );
};
